// extracted by mini-css-extract-plugin
module.exports = {"downloadClient":"DownloadClient-downloadClient-16zZl Card-card-1iGZk","name":"DownloadClient-name-2tbXV","enabled":"DownloadClient-enabled-h2UaL"};